export enum ProfileType {
  ADMIN = 'Administrateur',
  DIRECTION = 'Direction',
  'DIRECTION+' = 'Direction +',
  MMIE = 'MMIE',
  STRUCTURE = 'Structure',
  TERRITORY = 'Territoire',
  RECEPTION = 'Accueil',
}

export const labelsByProfileType: Map<ProfileType, string> = new Map<ProfileType, string>(
  Object.keys(ProfileType).map((x: string) => [x, ProfileType[x]] as [ProfileType, string]),
);
